import React from 'react';
import { View, StyleSheet } from 'react-native';

import { TagLabel } from '../../TagLabel';
import type { ChallengeExpirationBadgeProps } from '../ChallengeCard.types';
import { getFormattedExpirationDate } from '../../../utils';

export const ChallengeExpirationBadge = ({
  expirationDate,
  isCompleted,
}: ChallengeExpirationBadgeProps) => {
  const endsText = getFormattedExpirationDate(expirationDate, 'Ends');

  return (
    <View style={styles.wrapper}>
      <TagLabel size="small" palette={isCompleted ? 'tertiary' : 'primary'}>
        {endsText}
      </TagLabel>
    </View>
  );
};

// ─── STYLES ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  wrapper: {
    alignSelf: 'flex-start',
  },
});
